import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Subject, iif, of } from 'rxjs';
import { concatMap, last, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TablesImportService {
    
    public takeUntilSubject: Subject<any> = new Subject();

    addTable(table) {
        const token = this.cookieService.get('accessToken');
        const queryParams = [
            `access_token=${token}`,
            `p=${encodeURIComponent(JSON.stringify(table))}`
        ];

        return this.http.post('/api/event/addTables', _.join(queryParams, "&"), {
            headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }

    updateTable(table) {
      const token = this.cookieService.get('accessToken');
      const queryParams = [
          `access_token=${token}`,
          `p=${encodeURIComponent(JSON.stringify(table))}`
      ];

      return this.http.post('/api/event/updateTable', _.join(queryParams, "&"), {
          headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
          }
      }).pipe(
        map(()=> {
          return table;
        })
      );
    }

    getTables(eventId) {
      const token = this.cookieService.get('accessToken');
      const queryParams = [
          `access_token=${token}`,
          `eventId=${eventId}`
      ];

      return this.http.post('/api/event/getTablesAdmin', _.join(queryParams, "&"), {
          headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
          }
      });
    }

    updateSeat(tableId, seat) {
      const token = this.cookieService.get('accessToken');
      const queryParams = [
          `access_token=${token}`,
          `p=${encodeURIComponent(JSON.stringify({tableId, seat}))}`
      ];

      return this.http.post('/api/event/table/seat/update', _.join(queryParams, "&"), {
          headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
          }
      });
    }

    addTableList(eventId, group) {
      const value = group.value;
      let list: any = []; 
      return of(...value.tables).pipe(
        concatMap((table: any) => {
          return this.addTable( {
            eventId: eventId,
            tableStartNum: table.tableNumber,
            tableEndNum: table.tableNumber,
            seats: table.seats,
            assignedSeating: table.assignedSeating,
            category: table.category || ""
          });
        }),
        last(),
        switchMap(()=> {
          return this.getTables(eventId);
        }),
        switchMap((tables: any)=> {
          list = tables;
          const result = [];
          for (let i = 0; i < value.tables.length; i++) {
            const element = value.tables[i];

            if(element.tableName != '') {
              const tableNum = element.tableNumber;
              const tabletoBeUpdated = tables.find(table => table.tableNum === tableNum);
  
              result.push({
                id: tabletoBeUpdated.id,
                seatingCapacity: tabletoBeUpdated.seatingCapacity,
                tableCategory: tabletoBeUpdated.tableCategory,
                tableName: element.tableName,
                assignedSeating: tabletoBeUpdated.assignedSeating
              });
            }
          }
          return  result.length > 0 ? of(...result): of(null);
        }),
        concatMap((table: any) => {
          return iif(() => {
            return _.isNull(table);
          }, of(null), of(table).pipe(
            switchMap(() => {
              return this.updateTable(table)
            })
          ));
        }),
        last(),
        switchMap(()=> {
          const result = [];
          for (let i = 0; i < value.seats.length; i++) {
            const element = value.seats[i];

            if(element.seatName == '') {
              continue;
            }  
            const tableNumber = element.tableNumber;
            const seatNumber = element.seatNumber;
            const table = list.find(table => table.tableNum === tableNumber);

            if(!table) {
              continue;
            } 
            const seatToBeUpdated = table.seats.find(seat => seat.seatNum === seatNumber);

            if(!seatToBeUpdated) {
              continue;
            }

            result.push({
              tableId: table.id,
              seat: {...seatToBeUpdated, seatName: element.seatName}
            });
          }
          return  result.length > 0 ? of(...result): of(null);
        }),
        concatMap((result: any)=> {
          return iif(() => {
            return _.isNull(result);
          }, of(null), of(result).pipe(
            switchMap(() => {
              return this.updateSeat(result.tableId, result.seat)
            })
          ));
        })
      );
    }

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
  ) { }
}
